// extracted by mini-css-extract-plugin
export default {"button":"DocNewFile_button__rjNkQ","icon":"DocNewFile_icon__669Ux"};